import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Pool/getCodigoPool`, method: 'GET', body: null})
}
